/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function updateSelectedVariantTitle(holder) {
    const productId = holder.getAttribute('data-quick-add-holder');
    if (!productId) return;
    
    const sizeOptions = holder.querySelectorAll('.size-option');
    const selectedVariantTitle = holder.querySelector(`#selected-variant-title-${productId}`);
    
    if (!sizeOptions.length || !selectedVariantTitle) return;
    
    // Function to map size abbreviations to full names
    function getFullSizeName(size) {
      switch (size) {
        case 'XS':
          return 'Extra Small';
        case 'S/M': 
          return 'Small/Medium';
        case 'M/L':
          return 'Medium/Large';
        case 'S':
          return 'Small';
        case 'M':
          return 'Medium';
        case 'L':
          return 'Large';
        case 'XL':
          return 'Extra Large';
        default:
          return size;
      }
    }
    
    sizeOptions.forEach(option => {
      option.addEventListener('change', function() {
        const selectedLabel = this.nextElementSibling;
        if (selectedLabel) {
          selectedVariantTitle.textContent = getFullSizeName(selectedLabel.textContent);
        }
      });
    });
  }
  
  // Function to initialize the event listeners on all quick add holders
  function initializeQuickAdd() {
    document.querySelectorAll('.quick-add__holder').forEach(function(holder) {
      updateSelectedVariantTitle(holder);
    });
  }

  window.initializeQuickAdd = initializeQuickAdd;
  initializeQuickAdd();

  setTimeout(() => {
    initializeQuickAdd();
  }, 3000);

  function registerInfiniteScrollLoadMoreButton() {
    const selectors = {
      loadMoreButton: ".js-load-more",
      totalPages: "[data-total-pages]",
      currentPage: "[data-current-page]",
      nextUrl: "[data-next-url]",
      loadMoreText: "[load-more-text]",
      loaderText: "[loader-text]",
      products: ".collection__products .grid-item.product-item:not(.product-grid-item-placeholder)",
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      totalProducts: ".total-products",
    };
  
    const hideClass = "hide";
    const loadMoreButton = document.querySelector(selectors.loadMoreButton);
  
    if (loadMoreButton == null) {
      return;
    }
  
    loadMoreButton.addEventListener("click", (e) => {
      const totalPagesValue = Number(document.querySelector(selectors.totalPages).value);
      let currentPage = document.querySelector(selectors.currentPage);
      let currentPageValue = parseInt(currentPage.value);
      let nextUrl = document.querySelector(selectors.nextUrl);
      let nextUrlValue = nextUrl ? nextUrl.value : null;

      if (nextUrlValue) {
        const urlObj = new URL(nextUrlValue, window.location.origin);
        urlObj.searchParams.delete('cursor');
        nextUrlValue = urlObj.pathname + urlObj.search;
      }
  
      loadMoreButton.setAttribute("disabled", true);
  
      const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
      const loaderText = loadMoreButton.querySelector(selectors.loaderText);
  
      loadMoreText.classList.add(hideClass);
      loaderText.classList.remove(hideClass);

      fetch(nextUrlValue)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          const products = doc.querySelectorAll(selectors.products);
          insertProducts(products);
  
          currentPage.value = currentPageValue + 1;
  
          if (currentPage.value >= totalPagesValue) {
            loadMoreButton.classList.add(hideClass);
  
            const currentProducts = document.querySelector(selectors.currentProducts);
            const totalProducts = document.querySelector(selectors.totalProducts);
            currentProducts.innerHTML = totalProducts.innerHTML;
          }

          const docNextUrl = doc.querySelector(selectors.nextUrl);
          if( docNextUrl && docNextUrl.value ) {
            nextUrl.value = docNextUrl.value;
          }
  
          loadMoreButton.removeAttribute("disabled");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);
  
          window.history.pushState({
            param: Shopify.queryParams
          }, document.title, nextUrlValue);

          initializeQuickAdd();
        })
        .catch((error) => {
          console.warn("Loading more products failed", error);
          loadMoreButton.classList.add(hideClass);
        });
    });
  }
  
  function insertProducts(products, before = false) {
    const selectors = {
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      productCard: ".grid-item.product-item:not(.product-grid-item-placeholder)"
    };
  
    const productGrid = document.querySelector(selectors.productGrid);
  
    products.forEach((product) => {
      if (before) {
        productGrid.prepend(product);
      } else {
        productGrid.appendChild(product);
      }
    });
  
    const currentProducts = document.querySelector(selectors.currentProducts);
    currentProducts.innerHTML = productGrid.querySelectorAll(selectors.productCard).length;
  }

  registerInfiniteScrollLoadMoreButton();


  function moveAndDisplayProductInventoryBlock() {
    const productBlockElement = document.querySelector('.product__block.variant__countdown');
    const targetElement = document.getElementById('radioLegendLabel');
    
   
    if (productBlockElement !== null && targetElement !== null) {
      targetElement.appendChild(productBlockElement);
      productBlockElement.style.display = 'grid';
    } else {
      console.error('One or both elements not found');
    }
  }
  
  moveAndDisplayProductInventoryBlock();

  function applyTopStyling() {
    const nav = document.querySelector('.collection__nav');
    const filter = document.querySelector('.collection__sidebar__slide-out');
    const underlay = document.querySelector('.collection__products .underlay');
  
    if (!nav || !filter || !underlay) {
      return; 
    }
  
    // Check if the device is desktop
    if (window.innerWidth >= 750) {
      const navHeight = nav.getBoundingClientRect().height;
      const navTop = nav.getBoundingClientRect().top;
  
      filter.style.top = `${navTop + navHeight}px`;
      underlay.style.top = `${navTop + navHeight}px`;
    } else {
      filter.style.top = '';
      underlay.style.top = '';
    }
  }
  
  applyTopStyling();
  document.addEventListener('scroll', applyTopStyling);
  window.addEventListener('resize', applyTopStyling);  

  function applyFilterDesktopHeight() {
    const nav = document.querySelector('.collection__nav');
    const filter = document.querySelector('.collection__sidebar__slide-out');

    // If not desktop, return
    if (window.innerWidth < 750) {
      return;
    }

    // If window height is less than 700px, set a fixed height for the filter
    if (window.innerHeight < 700) {
      if (window.innerHeight < 500) {
        filter.classList.add('small-height-300');
      } else if (window.innerHeight < 600) {
        filter.classList.add('small-height-350');
      } else {
        filter.classList.add('small-height-400');
      }      
    } else {
      filter.classList.remove('small-height-400');
      filter.classList.remove('small-height-350');
      filter.classList.remove('small-height-300');
    }
  }

  applyFilterDesktopHeight();
  window.addEventListener('resize', applyFilterDesktopHeight);

  window.addEventListener('filterDone', (e) => {
    registerInfiniteScrollLoadMoreButton();
  });
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


async function addPreviousCollectionProducts() {
  const selectors = {
    products: ".collection__products .grid-item.product-item",
    productGrid: "div[data-products-grid] .grid",
  };

  const previousProductDivs = document.querySelectorAll('.js-collection-previous-products');
  const reversedPreviousProductDivs = Array.from(previousProductDivs);
  const previousProducts = [];

  const promises = reversedPreviousProductDivs.map(div => {
    const url = div.getAttribute('data-url');
    return fetch(url).then(response => response.text());
  });

  const responses = await Promise.all(promises);

  responses.forEach((html, index) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const products = doc.querySelectorAll(selectors.products);
    previousProducts.push(...products);
  });

  const productGrid = document.querySelector(selectors.productGrid);
  const placeholders = [...document.querySelectorAll('.product-grid-item-placeholder')];

  previousProducts.forEach((product, index) => {
    if (placeholders[index]) {
      placeholders[index].outerHTML = product.outerHTML;
    } else {
      productGrid.prepend(product);
    }
  });

  placeholders.slice(previousProducts.length).forEach(placeholder => placeholder.remove());
}

(async function () {
  await addPreviousCollectionProducts();
})();